export const changeIsLoadingSideContent = (isLoading) => {
  return {
    type: "CHANGE_ISLOADING_SIDE_CONTENT",
    isLoading,
  };
};
